export default __webpack_public_path__ + "static/media/Chery_Travel_Partner.06d7192b.webp";